// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__5xA1m"};